import { G, Path, Rect, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Delivery_Truck: React.FC<Props> = ({ fill }) => {
    return (
        <Svg fill={fill} id="Capa_1" x="0px" y="0px" width={"12pt"} height={"100%"} viewBox="0 0 512 512">
            <G>
                <G>
                    <Path d="M386.689,304.403c-35.587,0-64.538,28.951-64.538,64.538s28.951,64.538,64.538,64.538 c35.593,0,64.538-28.951,64.538-64.538S422.276,304.403,386.689,304.403z M386.689,401.21c-17.796,0-32.269-14.473-32.269-32.269 c0-17.796,14.473-32.269,32.269-32.269c17.796,0,32.269,14.473,32.269,32.269C418.958,386.738,404.485,401.21,386.689,401.21z" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M166.185,304.403c-35.587,0-64.538,28.951-64.538,64.538s28.951,64.538,64.538,64.538s64.538-28.951,64.538-64.538 S201.772,304.403,166.185,304.403z M166.185,401.21c-17.796,0-32.269-14.473-32.269-32.269c0-17.796,14.473-32.269,32.269-32.269 c17.791,0,32.269,14.473,32.269,32.269C198.454,386.738,183.981,401.21,166.185,401.21z" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M430.15,119.675c-2.743-5.448-8.32-8.885-14.419-8.885h-84.975v32.269h75.025l43.934,87.384l28.838-14.5L430.15,119.675z" />
                </G>
            </G>
            <G>
                <G>
                    <Rect x="216.202" y="353.345" width="122.084" height="32.269" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M117.781,353.345H61.849c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h55.933 c8.912,0,16.134-7.223,16.134-16.134C133.916,360.567,126.693,353.345,117.781,353.345z" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M508.612,254.709l-31.736-40.874c-3.049-3.937-7.755-6.239-12.741-6.239H346.891V94.655 c0-8.912-7.223-16.134-16.134-16.134H61.849c-8.912,0-16.134,7.223-16.134,16.134s7.223,16.134,16.134,16.134h252.773v112.941 c0,8.912,7.223,16.134,16.134,16.134h125.478l23.497,30.268v83.211h-44.639c-8.912,0-16.134,7.223-16.134,16.134 c0,8.912,7.223,16.134,16.134,16.134h60.773c8.912,0,16.134-7.223,16.135-16.134V264.605 C512,261.023,510.806,257.538,508.612,254.709z" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M116.706,271.597H42.487c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h74.218 c8.912,0,16.134-7.223,16.134-16.134C132.84,278.82,125.617,271.597,116.706,271.597z" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M153.815,208.134H16.134C7.223,208.134,0,215.357,0,224.269s7.223,16.134,16.134,16.134h137.681 c8.912,0,16.134-7.223,16.134-16.134S162.727,208.134,153.815,208.134z" />
                </G>
            </G>
            <G>
                <G>
                    <Path d="M180.168,144.672H42.487c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h137.681 c8.912,0,16.134-7.223,16.134-16.134C196.303,151.895,189.08,144.672,180.168,144.672z" />
                </G>
            </G>
        </Svg>
    );
};

export default Delivery_Truck;
